<div *ngIf="loading"
  class="loading">
  <mat-spinner></mat-spinner>
</div>
<router-outlet></router-outlet>